import { Alert, Button, Checkbox, Table } from '@trussworks/react-uswds';
import ExternalLink from '@components/external-link/ExternalLink';
import { useIpac, useRequest } from '@stores';
import Loader from '@src/app-components/loader/Loader';

const IPACSpeciesTable = ({ fetchSpecies = () => {}, handleSpeciesCheck = () => {}, isLoading, isError }) => {
  const { endangeredSpeciesList, selectedSpecies } = useIpac();
  const isReadOnly = useRequest((state) => state.isFormReadOnly);

  const hasSpecies = Boolean(endangeredSpeciesList?.length);
  const showIpacUnavailable = isError && !hasSpecies;
  return (
    <>
      {showIpacUnavailable && (
        <>
          <Alert className='margin-bottom-1' type='error' headingLevel='h3'>
            USFWS IPAC species data is currently unavailable. Please manually enter any relevant species information in
            the fields below.
          </Alert>
        </>
      )}
      <Table compact bordered fullWidth>
        <thead>
          <tr>
            <th scope='col'>Select</th>
            <th scope='col'>Common Name</th>
            <th scope='col'>Scientific Name</th>
            <th scope='col'>Listing Status</th>
            <th scope='col'>Species Profile URL</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan='5'>
                <div className='grid-row grid-gap-1 flex-justify-center flex-align-center padding-2'>
                  <Loader variant='inline' loaderText='Loading...' />
                </div>
              </td>
            </tr>
          ) : showIpacUnavailable ? (
            <tr>
              <td colSpan='5'>
                <div className='grid-row grid-gap-3 flex-justify-center flex-align-center padding-2'>
                  <span>USFWS IPAC service is unavailable at this time.</span>
                  <Button className='button-small' type='button' onClick={() => fetchSpecies()}>
                    Retry
                  </Button>
                </div>
              </td>
            </tr>
          ) : endangeredSpeciesList?.length === 0 ? (
            <tr>
              <td colSpan='5'>No USFWS IPAC species found in project location.</td>
            </tr>
          ) : (
            endangeredSpeciesList?.map((species, index) => (
              <tr key={index}>
                <td>
                  <Checkbox
                    id={species.optionalCommonName}
                    name={species.optionalCommonName}
                    onChange={handleSpeciesCheck}
                    checked={Array.isArray(selectedSpecies) && selectedSpecies.includes(species.optionalCommonName)}
                    disabled={isReadOnly}
                  />
                </td>
                <td>{species.optionalCommonName}</td>
                <td>{species.optionalScientificName}</td>
                <td>{species.listingStatusName.toUpperCase()}</td>
                <td>
                  <ExternalLink
                    href={species.speciesProfileUrl}
                    title={species.speciesCommonName}
                    content={species.speciesProfileUrl}
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </>
  );
};
export default IPACSpeciesTable;
